module.exports = __webpack_public_path__ + "img/logo.cd98911b.svg";